import { Injectable } from "@angular/core";
import * as signalR from "@aspnet/signalr";
import { HubConnectionBuilder } from "@aspnet/signalr";
import { Action, Selector, State, StateContext, Store } from "@ngxs/store";
// Removed import of SelectorDefTuple from private NGXS API
import { lastValueFrom } from "rxjs";
import { tap } from "rxjs/operators";
import { EnvService } from "src/app/env.service";
import { getbaseUrl } from "../helpers/util";
import {
  IPlanningData,
  IPlanningFilters,
  IPlanningOptions,
} from "../model/interfaces";
import {
  Assignment,
  AssignmentStatus,
  candidateVM,
  LearningObjective,
  LearningObjectiveOrderVM,
  User,
} from "../model/model";
import { LocalstorageService } from "../services/localstorage-service.service";
import { PlanningService } from "../services/planning.service";
import { UserService } from "../services/user.service";
import { Candidate, CitoApplicationModule, UserGroup } from "./../model/model";
import { ModifiedAssessmentResultAction } from "./assignment-details.state";
import { DashboardState, DashboardStateModel } from "./dashboard.state";
import {
  CheckboxModel,
  FilterBySearchTextAction,
} from "./learning-objectives.state";

export class PlanCandidateAction {
  static type = "[Planning] Add assignment";
  constructor(public candidateId: string, public learningObjectiveId: string) {}
}
export class UnplanCandidateAction {
  static type = "[Planning] Remove assignment";
  constructor(public candidateId: string, public learningObjectiveId: string) {}
}
export class UnplanGroupAction {
  static type = "[Planning] unplan group";
  constructor(public learningObjectiveId: string, public plan = false) {}
}
export class PlanGroupAction {
  static type = "[Planning] plan group";
  constructor(public learningObjectiveId: string, public plan = true) {}
}
export class PlanSelectionAction {
  static type = "[Planning] plan selection";
  constructor(public learningObjectiveIds: string[]) {}
}
export class UnplanSelectionAction {
  static type = "[Planning] unplan selection";
  constructor(public learningObjectiveIds: string[]) {}
}
export class MarkFailAction {
  static type = "[Planning] Mark fail";
  constructor(public candidateId: string, public learningObjectiveId: string) {}
}
export class MarkPassAction {
  static type = "[Planning] Mark pass";
  constructor(public candidateId: string, public learningObjectiveId: string) {}
}
export class ResetAssignmentAction {
  static type = "[Planning] reset the assignment";
  constructor(public candidateId: string, public learningObjectiveId: string) {}
}
export class ModifiedPlanningAction {
  static type = "[Planning] planning is modified";
  constructor(public assignments: Array<Assignment>) {}
}
export class LoadPlanningAction {
  static type = "[Planning] Load";
  constructor(public signalR: boolean = true) {}
}
export class SetSelectedAssignmentIdAction {
  static type = "[Planning] set selected assignmentId";
  constructor(public assignmentId: string) {}
}
export class ShowAssignStatusAction {
  static type = "[Planning] show assign a status for a learning objective";
  constructor(public id: string) {}
}
export class HideAssignStatusAction {
  static type = "[Planning] hide assign a status for a learning objective";
}
export class UpdateFilteredCandidatesAction {
  static type = "[Planning] Updated Filtered candidates";
  constructor() {}
}
export class FilterByGroupYearAction {
  static type = "[Planning] Updated Filter YearGroups";
  constructor(public filter: CheckboxModel[]) {}
}
export class FilterByReferenceLevelAction {
  static type = "[Planning] Updated Filter Referencelevel";
  constructor(public filter: CheckboxModel[]) {}
}
export class FilterByClassAction {
  static type = "[Planning] Updated Filter ClassGroups";
  constructor(public filter: string) {}
}
export class FilterPlanningAction {
  static type = "[Planning Filter] ";
  //constructor(public candidateId: string) { }
}
export class UpdateCandidateCheckboxAction {
  static type = "[Planning]filtered candidates";
  constructor(public candidate: User) {}
}
export class UpdateAllCandidateCheckboxAction {
  static type = "[Planning] filtered all candidates";
  constructor(public allCandidatesChecked: boolean) {}
}

export class UpdateProfileInPlanningAction {
  static type = "[Planning] Update candidate profile in planning";
  constructor(public candidateId: string, public profile: string[]) {}
}

export class SetYeargroupFiltersAction {
  static type = "[Planning] Set Yeargroupfilters";
  constructor(public filters: CheckboxModel[]) {}
}
export class UpdateYeargroupFiltersAction {
  static type = "[Planning] update Yeargroupfilters";
  constructor(public filter: { id: number; value: boolean }) {}
}
export class CheckUncheckAllYeargroupFiltersAction {
  static type = "[Planning] update all Yeargroupfilters";
  constructor(public filter: boolean) {}
}

export class SetReferenceLevelCandidateFiltersAction {
  static type = "[Planning] Set ReferenceLevelCandidateFilters";
  constructor(public filters: CheckboxModel[]) {}
}
export class UpdateReferenceLevelCandidateFiltersAction {
  static type = "[Planning] update ReferenceLevelCandidateFilters";
  constructor(public filter: { id: number; value: boolean }) {}
}
export class CheckUncheckAllReferenceLevelCandidateFiltersAction {
  static type = "[Planning] update all ReferenceLevelCandidateFilters";
  constructor(public filter: boolean) {}
}

export class SetFiltersFromLocalStorageAction {
  static type = "[Planning] set filters from local storage";
  constructor() {}
}

export interface PlanningStateModel {
  loaded: boolean;
  planning: IPlanningData;
  options: IPlanningOptions;
  selectedAssignment: string;
  isResetting: boolean;
  selectedLearningObjective: LearningObjective;
  learningObjectiveOrders: LearningObjectiveOrderVM[];
  filters: IPlanningFilters;
  assignmentsBackup?: Assignment[];
}

const closeAssignmentDetails = (
  state: PlanningStateModel
): PlanningStateModel => ({
  ...state,
  selectedAssignment: "",
  options: { ...state.options, assignStatusOpened: false },
});

const closeAll = (options: IPlanningOptions): IPlanningOptions => ({
  ...options,
  learningObjectiveOpened: false,
  progressOpened: false,
  assignStatusOpened: false,
});

export interface DataState {
  loaded: boolean;
  isResetting: boolean;
}

export const initialState: PlanningStateModel = {
  loaded: false,
  selectedAssignment: "",
  planning: {
    groupname: null,
    groups: [],
    candidates: [],
    assignments: [],
    //filteredCandidates: [],
    //filteredAssignments: [],
  },
  options: closeAll(undefined),
  isResetting: false,
  learningObjectiveOrders: [],
  selectedLearningObjective: null,
  filters: {
    yeargroupfilter: [],
    classGroupFilter: null,
    referenceLevelFilter: [],
  },
};

export interface candidateData {
  candidatesInList: candidateVM[];
  loaded: boolean;
}

@State<PlanningStateModel>({
  name: "planning",
  defaults: initialState,
})
@Injectable()
export class PlanningState {
  constructor(
    private planningService: PlanningService,
    private store: Store,
    private userService: UserService,
    private env: EnvService,
    private storageService: LocalstorageService
  ) {}

  @Selector()
  static groupname(state: PlanningStateModel): string {
    return state.planning.groupname;
  }

  @Selector()
  static groups(state: PlanningStateModel): UserGroup[] {
    return state.planning.groups;
  }

  @Selector()
  static dataState(state: PlanningStateModel): DataState {
    return { loaded: state.loaded, isResetting: state.isResetting };
  }

  @Selector()
  static options(state: PlanningStateModel) {
    return state.options;
  }

  @Selector()
  static assignments(state: PlanningStateModel) {
    return state.planning.assignments;
  }

  @Selector()
  static candidates(state: PlanningStateModel) {
    // let counter = 0;
    // state.planning.candidates.forEach(c => {
    //   if (counter % 2 !== 0) {
    //     c.yearGroup = 7;
    //   } else {
    //     c.yearGroup = 8;
    //   }
    //   counter++;
    // });

    // state.planning.candidates.forEach(c => {
    //   //c.yearGroup = parseInt(c.yearGroup, 10);
    //   if (c.preposition) {
    //     c.inserts = '.' + c.preposition.match(/\b\w/g).join('.');
    //   }
    // });
    return state.planning.candidates;
  }

  // Use the documented multi-state selector pattern for your NGXS version
  @Selector([PlanningState, DashboardState])
  static candidatesPlaceholder(
    state: PlanningStateModel,
    dashboardstate: DashboardStateModel
  ): string {
    const candidates =
      state.planning?.candidates?.filter((c) => c.checked) || [];
    const f = state.filters;
    const filteredCandidates =
      candidates?.filter(
        (c: User) =>
          (f.yeargroupfilter && c.yearGroup > 0
            ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter)
            : true) &&
          (f.referenceLevelFilter
            ? PlanningState.isReferenceLevelInFilter(
                c,
                f.referenceLevelFilter,
                dashboardstate.module
              )
            : true) &&
          PlanningState.isCandidateSelected(c)
      ) || [];
    return `${filteredCandidates.length}`;
  }

  @Selector([PlanningState, DashboardState])
  static filteredCandidates(
    state: PlanningStateModel,
    dashboardstate: DashboardStateModel
  ) {
    const candidates = state.planning?.candidates;
    const f = state.filters;
    const filteredCandidates = candidates?.filter(
      (c) =>
        (f.yeargroupfilter
          ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter)
          : true) &&
        (f.referenceLevelFilter
          ? PlanningState.isReferenceLevelInFilter(
              c,
              f.referenceLevelFilter,
              dashboardstate.module
            )
          : true) &&
        PlanningState.isCandidateSelected(c)
    );
    return filteredCandidates;
  }

  @Selector([PlanningState, DashboardState])
  static visibleCandidates(
    state: PlanningStateModel,
    dashboardstate: DashboardStateModel
  ) {
    const candidates = state.planning?.candidates;

    const f = state.filters;
    const visibleCandidates =
      candidates?.filter(
        (c) =>
          (f.yeargroupfilter
            ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter)
            : true) &&
          (f.referenceLevelFilter
            ? PlanningState.isReferenceLevelInFilter(
                c,
                f.referenceLevelFilter,
                dashboardstate.module
              )
            : true)
      ) || [];

    return visibleCandidates;
  }

  @Selector([PlanningState, DashboardState])
  static filteredAssignments(
    state: PlanningStateModel,
    dashboardstate: DashboardStateModel
  ) {
    const candidates = state.planning?.candidates;
    const f = state.filters;
    const filteredCandidates =
      candidates?.filter((c) => {
        const isYeargroupInFilter =
          PlanningState.isYearGroupInFilter(c, f.yeargroupfilter) ?? true;
        const isReferenceLevelInFilter =
          PlanningState.isReferenceLevelInFilter(
            c,
            f.referenceLevelFilter,
            dashboardstate.module
          ) ?? true;
        const isCandidateSelected =
          PlanningState.isCandidateSelected(c) ?? true;

        return (
          isYeargroupInFilter && isReferenceLevelInFilter && isCandidateSelected
        );
      }) || [];
    const assignments =
      state.planning?.assignments?.filter((a) =>
        filteredCandidates.find((fc) => fc.id === a.candidateId)
      ) || [];
    return assignments;
  }

  @Selector()
  static selectedAssignment(state: PlanningStateModel) {
    return (
      state.planning?.assignments?.find(
        (a) => a.id === state.selectedAssignment
      ) || null
    );
  }

  @Selector()
  static filters(state: PlanningStateModel) {
    const selectedGroupId = state.planning?.candidates[0].groupList[0];
    state.filters.classGroupFilter = selectedGroupId;
    return state.filters;
  }

  @Selector()
  static selectedGroupYearFilter(state: PlanningStateModel) {
    return state.filters.yeargroupfilter;
  }

  @Selector()
  static selectedClassFilter(state: PlanningStateModel) {
    return state.filters.classGroupFilter;
  }

  private static isYearGroupInFilter(candidate, yeargroupFilter): boolean {
    const allchecked = yeargroupFilter.every((filter) => filter.checked);

    if (candidate.yearGroup > 0 || !allchecked) {
      const yeargroupIsInFilter = yeargroupFilter
        .filter((r) => r.checked)
        .find((r) => {
          if (r.value == candidate.yearGroup) {
            return true;
          } else {
            return false;
          }
        });

      return yeargroupIsInFilter ? true : false;
    } else {
      return true;
    }
  }

  private static isReferenceLevelInFilter(
    candidate: Candidate,
    referenceLevelFilter: CheckboxModel[],
    module: CitoApplicationModule
  ): boolean {
    const allchecked = referenceLevelFilter.every((filter) => filter.checked);

    const learningrouteList =
      module === 0
        ? candidate.learningRoutesList
        : candidate.learningRoutesSpellingList;
    if (learningrouteList || !allchecked) {
      const referenceLevelIsInFilter = referenceLevelFilter
        .filter((r) => r.checked)
        .find((r) => {
          if (r.value === learningrouteList[0]) {
            return true;
          } else if (r.value === "Geen profiel" && !learningrouteList[0]) {
            return true;
          } else {
            return false;
          }
        });

      return referenceLevelIsInFilter ? true : false;
    } else {
      return true;
    }
  }

  private static isCandidateSelected(candidate): boolean {
    const candidateIsSelected = candidate.checked;
    return candidateIsSelected;
  }

  @Selector()
  static yeargroupFilters(state: PlanningStateModel): CheckboxModel[] {
    return state.filters.yeargroupfilter;
  }

  @Selector()
  static referencelevelFilters(state: PlanningStateModel): CheckboxModel[] {
    return state.filters.referenceLevelFilter;
  }

  @Selector()
  static allYeargroupsChecked(state: PlanningStateModel): boolean {
    return state.filters.yeargroupfilter.every(
      (item: CheckboxModel) => item.checked === true
    );
  }

  @Selector()
  static AllReferenceLevelsChecked(state: PlanningStateModel): boolean {
    return state.filters.referenceLevelFilter.every(
      (item: CheckboxModel) => item.checked === true
    );
  }

  @Selector()
  static yeargroupPlaceholder(state: PlanningStateModel): string {
    const allchecked = state.filters.yeargroupfilter.every(
      (item: CheckboxModel) => item.checked === true
    );
    const checkedfilters = state.filters.yeargroupfilter
      .filter((f) =>
        state.planning?.candidates?.find((c) => c.yearGroup == f.value)
      )
      .filter((f) => f.checked);
    if (allchecked) return "Alle";
    if (checkedfilters.length > 0)
      return `${checkedfilters.length} filters actief`;
    if (checkedfilters.length === 0) return "Geen filters actief";
    else return checkedfilters.map((filter) => filter.value).join(", ");
  }

  @Selector()
  static referenceLevelPlaceholder(state: PlanningStateModel): string {
    const allchecked = state.filters.referenceLevelFilter.every(
      (item: CheckboxModel) => item.checked === true
    );
    const checkedfilters = state.filters.referenceLevelFilter.filter(
      (f) => f.checked
    );
    if (allchecked) return "Alle";
    if (checkedfilters.length > 0)
      return `${checkedfilters.length} filters actief`;
    if (checkedfilters.length === 0) return "Geen filters actief";
    else return checkedfilters.map((filter) => filter.value).join(", ");
  }

  @Action(SetYeargroupFiltersAction)
  setYgFilters(
    ctx: StateContext<PlanningStateModel>,
    action: SetYeargroupFiltersAction
  ) {
    const state = ctx.getState();

    ctx.patchState({
      filters: {
        ...state.filters,
        yeargroupfilter: action.filters,
      },
    });
  }

  @Action(UpdateYeargroupFiltersAction)
  updateYgFilters(
    ctx: StateContext<PlanningStateModel>,
    action: UpdateYeargroupFiltersAction
  ) {
    const state = ctx.getState();
    const _filters = {
      filters: {
        ...state.filters,
        yeargroupfilter: state.filters.yeargroupfilter.map(
          (yg: CheckboxModel) => {
            if (yg.id === action.filter.id) {
              return {
                ...yg,
                checked: action.filter.value,
              };
            }
            return yg;
          }
        ),
      },
    };
    this.setLocalStorage("yeargroupfilter", _filters.filters.yeargroupfilter);
    ctx.patchState(_filters);
  }

  @Action(CheckUncheckAllYeargroupFiltersAction)
  checkUncheckYgFilters(
    ctx: StateContext<PlanningStateModel>,
    action: CheckUncheckAllYeargroupFiltersAction
  ) {
    const state = ctx.getState();
    const _filters = {
      filters: {
        ...state.filters,
        yeargroupfilter: state.filters.yeargroupfilter.map(
          (yg: CheckboxModel) => {
            return {
              ...yg,
              checked: action.filter,
            };
          }
        ),
      },
    };
    this.setLocalStorage("yeargroupfilter", _filters.filters.yeargroupfilter);
    ctx.patchState(_filters);
  }

  @Action(SetReferenceLevelCandidateFiltersAction)
  setReferencelevelFilters(
    ctx: StateContext<PlanningStateModel>,
    action: SetReferenceLevelCandidateFiltersAction
  ) {
    const state = ctx.getState();
    ctx.patchState({
      filters: {
        ...state.filters,
        referenceLevelFilter: action.filters,
      },
    });
  }

  @Action(UpdateReferenceLevelCandidateFiltersAction)
  updateReferencelevelFilters(
    ctx: StateContext<PlanningStateModel>,
    action: UpdateReferenceLevelCandidateFiltersAction
  ) {
    const state = ctx.getState();
    const _filters = {
      filters: {
        ...state.filters,
        referenceLevelFilter: state.filters.referenceLevelFilter.map(
          (rf: CheckboxModel) => {
            if (rf.id === action.filter.id) {
              return {
                ...rf,
                checked: action.filter.value,
              };
            }
            return rf;
          }
        ),
      },
    };

    const citomodule = this.store.selectSnapshot(DashboardState.citomodule);

    if (citomodule === CitoApplicationModule.Rekenen) {
      this.setLocalStorage(
        "referenceLevelFilterRekenen",
        _filters.filters.referenceLevelFilter
      );
    } else {
      this.setLocalStorage(
        "referenceLevelFilterSpelling",
        _filters.filters.referenceLevelFilter
      );
    }

    ctx.patchState(_filters);
  }

  @Action(CheckUncheckAllReferenceLevelCandidateFiltersAction)
  checkUncheckReferencelevelFilters(
    ctx: StateContext<PlanningStateModel>,
    action: CheckUncheckAllReferenceLevelCandidateFiltersAction
  ) {
    const state = ctx.getState();
    const _filters = {
      filters: {
        ...state.filters,
        referenceLevelFilter: state.filters.referenceLevelFilter.map(
          (rf: CheckboxModel) => {
            return {
              ...rf,
              checked: action.filter,
            };
          }
        ),
      },
    };
    this.setLocalStorage(
      "referenceLevelFilter",
      _filters.filters.referenceLevelFilter
    );
    ctx.patchState(_filters);
  }

  @Action(UpdateProfileInPlanningAction)
  updateProfile(
    ctx: StateContext<PlanningStateModel>,
    candidate: UpdateProfileInPlanningAction
  ) {
    const state = ctx.getState();
    const citomodule = this.store.selectSnapshot(DashboardState.citomodule);
    const candidates = state.planning?.candidates.map((can) => {
      if (can.id === candidate.candidateId) {
        return {
          ...can,
          learningRoutesList:
            citomodule === CitoApplicationModule.Rekenen
              ? candidate.profile
              : can.learningRoutesList,
          learningRoutesSpellingList:
            citomodule === CitoApplicationModule.Spelling
              ? candidate.profile
              : can.learningRoutesSpellingList,
        };
      }
      return can;
    });
    ctx.patchState({
      planning: { ...state.planning, candidates: candidates },
    });
  }

  @Action(UpdateCandidateCheckboxAction)
  UpdateCandidateCheckbox(
    ctx: StateContext<PlanningStateModel>,
    action: UpdateCandidateCheckboxAction
  ) {
    let updatedCandidate = { ...action.candidate };
    updatedCandidate.checked = !updatedCandidate.checked;

    const state = ctx.getState();

    const _candidates = state.planning?.candidates;
    const candidates = [..._candidates];
    const foundIndex = candidates.findIndex((x) => x.id == action.candidate.id);
    candidates[foundIndex] = updatedCandidate;
    this.setLocalStorage("candidates", candidates);
    ctx.patchState({
      planning: { ...state.planning, candidates: candidates },
    });
  }

  // @Action(UpdateFilteredCandidatesAction)
  // UpdateFilteredCandidates(ctx: StateContext<PlanningStateModel>) {
  //   const state = ctx.getState();
  //   const candidates = state.planning.candidates;
  //   const f = state.filters;
  //   const filteredCandidates = candidates.filter(c =>
  //   (
  //     ((f.yeargroupfilter && c.yearGroup > 0) ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter) : true) &&
  //     ((f.referenceLevelFilter) ? PlanningState.isReferenceLevelInFilter(c, f.referenceLevelFilter) : true) &&
  //     PlanningState.isCandidateSelected(c)
  //   ));
  //   const assignments = state.planning.assignments.filter(a => filteredCandidates.find(fc => fc.id === a.candidateId));
  //   ctx.patchState({
  //    // planning: { ...state.planning, filteredCandidates: filteredCandidates, filteredAssignments: assignments }
  //     planning: { ...state.planning, candidates: filteredCandidates,assignments: assignments }
  //   });
  // }

  @Action(UpdateAllCandidateCheckboxAction)
  UpdateAllCandidateCheckbox(
    ctx: StateContext<PlanningStateModel>,
    action: any
  ) {
    const state = ctx.getState();
    // Use JSON methods for deep copy
    const checkboxes = JSON.parse(JSON.stringify(state.planning?.candidates));
    const candidates = checkboxes.map((c: User) => {
      c.checked = action.allCandidatesChecked;
      return c;
    });
    // const filteredCandidates = candidates.filter(c => c.checked === true);
    // const assignments = state.planning.assignments.filter(a => filteredCandidates.find(f => f.id === a.candidateId));
    this.setLocalStorage("candidates", candidates);
    ctx.patchState({
      planning: { ...state.planning, candidates: candidates },
      // planning: { ...state.planning, candidates: candidates, filteredCandidates: candidates, filteredAssignments: assignments}
    });
  }

  @Action(FilterByGroupYearAction)
  filterByYearGroup(
    ctx: StateContext<PlanningStateModel>,
    action: FilterByGroupYearAction
  ) {
    const state = ctx.getState();
    ctx.patchState({
      filters: { ...state.filters, yeargroupfilter: action.filter },
    });
    //this.store.dispatch(new UpdateFilteredCandidatesAction);
  }

  @Action(FilterByReferenceLevelAction)
  filterByReferenceLevelAction(
    ctx: StateContext<PlanningStateModel>,
    action: FilterByReferenceLevelAction
  ) {
    const state = ctx.getState();
    ctx.patchState({
      filters: { ...state.filters, referenceLevelFilter: action.filter },
    });
    //this.store.dispatch(new UpdateFilteredCandidatesAction);
  }

  @Action(FilterByClassAction)
  filterByClassGroup(
    ctx: StateContext<PlanningStateModel>,
    action: FilterByClassAction
  ) {
    const state = ctx.getState();

    this.setLocalStorage("groupId", action.filter);

    ctx.patchState({ planning: initialState.planning, loaded: false });
    return this.planningService.getPlanningData(action.filter).pipe(
      tap((planning) => {
        ctx.patchState({ planning: planning, loaded: true });
      })
    );
  }

  @Action(LoadPlanningAction)
  loading(ctx: StateContext<PlanningStateModel>, action: LoadPlanningAction) {
    const state = ctx.getState();

    const previousSessionData = this.storageService.get(
      `previousSession-${this.userService.user.id}`
    );
    let groupId;
    previousSessionData &&
    previousSessionData.groupId &&
    this.userService.user.groupList.find(
      (g) => g === previousSessionData.groupId
    )
      ? (groupId = previousSessionData.groupId)
      : (groupId = this.userService.user.groupList[0]);

    ctx.patchState({ loaded: false });
    return this.planningService.getPlanningData(groupId).pipe(
      tap((planning) => {
        if (action.signalR) {
          this.initSignalR();
        } // init signalR when planning data is retrieved.
        ctx.patchState({ planning: planning, loaded: true });
      })
    );
  }

  @Action([FilterBySearchTextAction])
  filterByDomain(ctx: StateContext<PlanningStateModel>) {
    const state = ctx.getState();
    ctx.setState({ ...closeAssignmentDetails(state) });
  }
  @Action(ModifiedPlanningAction)
  modifiedPlanningFromSignalR(
    ctx: StateContext<PlanningStateModel>,
    action: ModifiedPlanningAction
  ) {
    const state = ctx.getState();
    ctx.patchState({
      planning: {
        ...state.planning,
        assignments:
          state.planning?.assignments?.map((assignment) => {
            const matchAssignment = action.assignments.find(
              (a) =>
                a.candidateId === assignment.candidateId &&
                a.learningObjectiveId === assignment.learningObjectiveId
            );
            return matchAssignment ? matchAssignment : assignment;
          }) || [],
        // filteredAssignments:
        //   state.planning.filteredAssignments.map(assignment => {
        //     const matchAssignment = action.assignments.find(a =>
        //       a.candidateId === assignment.candidateId && a.learningObjectiveId === assignment.learningObjectiveId);
        //     return matchAssignment ? matchAssignment : assignment;
        //   })
      },
    });
  }
  @Action([
    PlanCandidateAction,
    UnplanCandidateAction,
    MarkFailAction,
    MarkPassAction,
    ResetAssignmentAction,
  ])
  waitingForActionToBeConfirmed(
    ctx: StateContext<PlanningStateModel>,
    action: PlanCandidateAction
  ) {
    const state = ctx.getState();
    ctx.patchState({
      assignmentsBackup: state.planning?.assignments,
      planning: {
        ...state.planning,
        assignments:
          state.planning?.assignments?.map((a) =>
            a.candidateId === action.candidateId &&
            a.learningObjectiveId === action.learningObjectiveId
              ? { ...a, status: AssignmentStatus.AwaitingUpdate }
              : a
          ) || [],

        // filteredAssignments: state.planning.filteredAssignments.map(a =>
        //   a.candidateId === action.candidateId && a.learningObjectiveId === action.learningObjectiveId ?
        //     { ...a, status: AssignmentStatus.AwaitingUpdate } : a)
      },
    });
  }

  @Action([PlanCandidateAction, ResetAssignmentAction])
  planningCandidate(
    _ctx: StateContext<PlanningStateModel>,
    action: PlanCandidateAction
  ) {
    const state = _ctx.getState();

    let result = null;

    try {
      const plan$ = this.planningService.plan(
        action.learningObjectiveId,
        action.candidateId
      );
      result = lastValueFrom(plan$);
    } catch (e) {
      console.error(e);
      _ctx.patchState({
        assignmentsBackup: [],
        planning: {
          ...state.planning,
          assignments: state.assignmentsBackup,
          //filteredAssignments: state.assignmentsBackup,
        },
      });
    }

    return result;
  }

  @Action(UnplanCandidateAction)
  unplanningCandidate(
    _ctx: StateContext<PlanningStateModel>,
    action: UnplanCandidateAction
  ) {
    const state = _ctx.getState();

    let result = null;

    try {
      const unplan$ = this.planningService.unplan(
        action.learningObjectiveId,
        action.candidateId
      );
      result = lastValueFrom(unplan$);
    } catch (error) {
      console.error(error);
      _ctx.patchState({
        assignmentsBackup: [],
        planning: {
          ...state.planning,
          assignments: state.assignmentsBackup,
          //filteredAssignments: state.assignmentsBackup,
        },
      });
    }

    return result;
  }

  @Action(MarkFailAction)
  markingFail(_ctx: StateContext<PlanningStateModel>, action: MarkFailAction) {
    return this.planningService.markFail(
      action.learningObjectiveId,
      action.candidateId
    );
  }
  @Action(MarkPassAction)
  markingPass(_ctx: StateContext<PlanningStateModel>, action: MarkPassAction) {
    return this.planningService.markPass(
      action.learningObjectiveId,
      action.candidateId
    );
  }
  @Action([PlanGroupAction])
  waitPlanGroupToBeConfirmed(
    ctx: StateContext<PlanningStateModel>,
    action: PlanGroupAction
  ) {
    const state = ctx.getState();
    const groupId = state.planning?.candidates[0].groupList[0];
    const yearGroup = state.filters.yeargroupfilter;
    const candidates = state.planning?.candidates;
    ctx.patchState({
      assignmentsBackup: state.planning?.assignments,
      planning: {
        ...state.planning,
        assignments: state.planning?.assignments.map((a) => {
          const matchAssignment =
            candidates.find((c) => c.id === a.candidateId) || [];

          return a.learningObjectiveId === action.learningObjectiveId &&
            a.status === AssignmentStatus.Unassigned &&
            a.groupId === groupId &&
            matchAssignment
            ? { ...a, status: AssignmentStatus.AwaitingUpdate }
            : a;
        }),

        // filteredAssignments: state.planning.filteredAssignments.map(a => {
        //   const matchAssignment = candidates.find(c => c.id === a.candidateId);

        //   return a.learningObjectiveId === action.learningObjectiveId && a.status === AssignmentStatus.Unassigned && a.groupId === groupId && matchAssignment ?
        //     { ...a, status: AssignmentStatus.AwaitingUpdate } : a
        // })
      },
    });
  }
  @Action([UnplanGroupAction])
  waitUnplanGroupToBeConfirmed(
    ctx: StateContext<PlanningStateModel>,
    action: UnplanGroupAction
  ) {
    const state = ctx.getState();
    const groupId = state.planning?.candidates[0].groupList[0];
    const yearGroup = state.filters.yeargroupfilter;
    const candidates = state.planning?.candidates;
    ctx.patchState({
      assignmentsBackup: state.planning?.assignments,
      planning: {
        ...state.planning,
        assignments: state.planning?.assignments.map((a) => {
          const matchAssignment = candidates.find(
            (c) => c.id === a.candidateId
          );

          return a.learningObjectiveId === action.learningObjectiveId &&
            a.status === AssignmentStatus.Assigned &&
            a.groupId === groupId &&
            matchAssignment
            ? { ...a, status: AssignmentStatus.AwaitingUpdate }
            : a;
        }),

        // filteredAssignments: state.planning.filteredAssignments.map(a => {
        //   const matchAssignment = candidates.find(c => c.id === a.candidateId);

        //   return a.learningObjectiveId === action.learningObjectiveId && a.status === AssignmentStatus.Assigned && a.groupId === groupId && matchAssignment ?
        //     { ...a, status: AssignmentStatus.AwaitingUpdate } : a
        // })
      },
    });
  }
  @Action(PlanGroupAction)
  planningGroup(
    _ctx: StateContext<PlanningStateModel>,
    action: PlanGroupAction
  ) {
    const state = _ctx.getState();
    const groupId = state.planning?.candidates[0].groupList[0];

    let result = null;

    try {
      const planGroup$ = this.planningService.planGroup(
        action.learningObjectiveId,
        groupId,
        null
      );
      result = lastValueFrom(planGroup$);
    } catch (error) {
      console.error(error);
      _ctx.patchState({
        assignmentsBackup: [],
        planning: {
          ...state.planning,
          assignments: state.assignmentsBackup,
          //filteredAssignments: state.assignmentsBackup,
        },
      });
    }
    return result;
  }
  @Action(UnplanGroupAction)
  unplanningGroup(
    _ctx: StateContext<PlanningStateModel>,
    action: PlanGroupAction
  ) {
    const state = _ctx.getState();
    const groupId = state.planning?.candidates[0].groupList[0];

    let result = null;

    try {
      const unplanGroup$ = this.planningService.unplanGroup(
        action.learningObjectiveId,
        groupId,
        null
      );
      result = lastValueFrom(unplanGroup$);
    } catch (error) {
      console.error(error);
      _ctx.patchState({
        assignmentsBackup: [],
        planning: {
          ...state.planning,
          assignments: state.assignmentsBackup,
          //filteredAssignments: state.assignmentsBackup,
        },
      });
    }
    return result;
  }

  @Action([PlanSelectionAction])
  waitPlanSelectionToBeConfirmed(
    ctx: StateContext<PlanningStateModel>,
    action: PlanSelectionAction
  ) {
    const state = ctx.getState();
    const citoModule = this.store.selectSnapshot(DashboardState.citomodule);
    const f = state.filters;
    let candidates = state.planning?.candidates?.filter((c) => c.checked);
    candidates =
      candidates?.filter(
        (c) =>
          (f.yeargroupfilter && c.yearGroup > 0
            ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter)
            : true) &&
          (f.referenceLevelFilter
            ? PlanningState.isReferenceLevelInFilter(
                c,
                f.referenceLevelFilter,
                citoModule
              )
            : true)
      ) || [];

    ctx.patchState({
      assignmentsBackup: state.planning.assignments,
      planning: {
        ...state.planning,
        assignments:
          state.planning?.assignments?.map((a) => {
            const matchAssignment = candidates.find(
              (c) => c.id === a.candidateId
            );
            return action.learningObjectiveIds.findIndex(
              (lo) => lo === a.learningObjectiveId
            ) > -1 &&
              a.status === AssignmentStatus.Unassigned &&
              matchAssignment
              ? { ...a, status: AssignmentStatus.AwaitingUpdate }
              : a;
          }) || [],

        // filteredAssignments: state.planning.filteredAssignments.map(a => {
        //   const matchAssignment = candidates.find(c => c.id === a.candidateId);

        //   return action.learningObjectiveIds.findIndex((lo) => lo === a.learningObjectiveId) > -1 && a.status === AssignmentStatus.Unassigned && matchAssignment ?
        //     { ...a, status: AssignmentStatus.AwaitingUpdate } : a
        // })
      },
    });
  }
  @Action(PlanSelectionAction)
  planningSelection(
    _ctx: StateContext<PlanningStateModel>,
    action: PlanSelectionAction
  ) {
    const state = _ctx.getState();
    const citoModule = this.store.selectSnapshot(DashboardState.citomodule);
    const candidates = state.planning?.candidates;
    const f = state.filters;
    const visibleCandidates =
      candidates?.filter(
        (c) =>
          (f.yeargroupfilter && c.yearGroup > 0
            ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter)
            : true) &&
          (f.referenceLevelFilter
            ? PlanningState.isReferenceLevelInFilter(
                c,
                f.referenceLevelFilter,
                citoModule
              )
            : true)
      ) || [];
    const candidateIds = visibleCandidates
      .filter((c) => c.checked)
      .map((candidate) => candidate.id);
    const loIds = action.learningObjectiveIds.filter((item, pos) => {
      return action.learningObjectiveIds.indexOf(item) == pos;
    });

    let result = null;
    try {
      const planSelection$ = this.planningService.planSelection(
        loIds,
        candidateIds
      );
      result = lastValueFrom(planSelection$);
    } catch (error) {
      console.error(error);
      _ctx.patchState({
        assignmentsBackup: [],
        planning: {
          ...state.planning,
          assignments: state.assignmentsBackup,
          //filteredAssignments: state.assignmentsBackup,
        },
      });
    }

    return result;
  }

  @Action([UnplanSelectionAction])
  waitUnplanSelectionToBeConfirmed(
    ctx: StateContext<PlanningStateModel>,
    action: UnplanSelectionAction
  ) {
    const state = ctx.getState();
    const citoModule = this.store.selectSnapshot(DashboardState.citomodule);
    const f = state.filters;
    let candidates = state.planning?.candidates?.filter((c) => c.checked);
    candidates =
      candidates?.filter(
        (c) =>
          (f.yeargroupfilter && c.yearGroup > 0
            ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter)
            : true) &&
          (f.referenceLevelFilter
            ? PlanningState.isReferenceLevelInFilter(
                c,
                f.referenceLevelFilter,
                citoModule
              )
            : true)
      ) || [];
    ctx.patchState({
      assignmentsBackup: state.planning.assignments,
      planning: {
        ...state.planning,
        assignments:
          state.planning?.assignments?.map((a) => {
            const matchAssignment = candidates.find(
              (c) => c.id === a.candidateId
            );

            return action.learningObjectiveIds.findIndex(
              (lo) => lo === a.learningObjectiveId
            ) > -1 &&
              a.status === AssignmentStatus.Assigned &&
              matchAssignment
              ? { ...a, status: AssignmentStatus.AwaitingUpdate }
              : a;
          }) || [],

        // filteredAssignments: state.planning.filteredAssignments.map(a => {
        //   const matchAssignment = candidates.find(c => c.id === a.candidateId);

        //   return action.learningObjectiveIds.findIndex((lo) => lo === a.learningObjectiveId) > -1 && a.status === AssignmentStatus.Assigned && matchAssignment ?
        //     { ...a, status: AssignmentStatus.AwaitingUpdate } : a
        // })
      },
    });
  }
  @Action(UnplanSelectionAction)
  unplanningSelection(
    _ctx: StateContext<PlanningStateModel>,
    action: UnplanSelectionAction
  ) {
    const state = _ctx.getState();
    const citoModule = this.store.selectSnapshot(DashboardState.citomodule);
    const candidates = state.planning?.candidates;
    const f = state.filters;
    const visibleCandidates =
      candidates?.filter(
        (c) =>
          (f.yeargroupfilter && c.yearGroup > 0
            ? PlanningState.isYearGroupInFilter(c, f.yeargroupfilter)
            : true) &&
          (f.referenceLevelFilter
            ? PlanningState.isReferenceLevelInFilter(
                c,
                f.referenceLevelFilter,
                citoModule
              )
            : true)
      ) || [];

    const candidateIds = visibleCandidates
      .filter((c) => c.checked)
      .map((candidate) => candidate.id);

    const loIds = action.learningObjectiveIds.filter((item, pos) => {
      return action.learningObjectiveIds.indexOf(item) == pos;
    });

    let result = null;

    try {
      const unplanSelection$ = this.planningService.unplanSelection(
        loIds,
        candidateIds
      );
      result = lastValueFrom(unplanSelection$);
    } catch (error) {
      console.error(error);
      _ctx.patchState({
        assignmentsBackup: [],
        planning: {
          ...state.planning,
          assignments: state.assignmentsBackup,
          //filteredAssignments: state.assignmentsBackup,
        },
      });
    }

    return result;
  }

  @Action(SetSelectedAssignmentIdAction)
  setSelectedAssignmentId(
    ctx: StateContext<PlanningStateModel>,
    action: SetSelectedAssignmentIdAction
  ) {
    ctx.patchState({ selectedAssignment: action.assignmentId });
  }

  @Action(ShowAssignStatusAction)
  showAssignStatus(
    ctx: StateContext<PlanningStateModel>,
    action: ShowAssignStatusAction
  ) {
    const state = ctx.getState();
    ctx.setState({
      ...state,
      selectedAssignment: action.id,
      options: {
        ...closeAll(state.options),
        assignStatusOpened: true,
      },
    });
  }
  @Action(HideAssignStatusAction)
  hideAssignment(ctx: StateContext<PlanningStateModel>) {
    ctx.patchState({
      options: { ...ctx.getState().options, assignStatusOpened: false },
    });
  }
  @Action(SetFiltersFromLocalStorageAction)
  setFiltersFromLocalstorage(ctx: StateContext<PlanningStateModel>) {
    const state = ctx.getState();

    const previousSessionData = this.storageService.get(
      `previousSession-${this.userService.user.id}`
    );

    let _yeargroupFilters = [];
    let _referenceLevelFilters = [];

    if (previousSessionData?.yeargroupfilter) {
      _yeargroupFilters = previousSessionData.yeargroupfilter;
      this.setLocalStorage(
        "yeargroupfilter",
        previousSessionData.yeargroupfilter
      );
    }

    if (previousSessionData?.referenceLevelFilter) {
      _referenceLevelFilters = previousSessionData.referenceLevelFilter;
      this.setLocalStorage(
        "referenceLevelFilter",
        previousSessionData.referenceLevelFilter
      );
    }

    ctx.patchState({
      filters: {
        ...state.filters,
        yeargroupfilter: _yeargroupFilters,
        referenceLevelFilter: _referenceLevelFilters,
      },
    });
  }

  private trimRight = (value, char) =>
    value.replace(new RegExp("[" + char + "]+$"), "");

  private initSignalR() {
    // if the backend and frontend are on the same url use the useUrl, otherwise use apibase.
    const base = this.trimRight(
      this.env.apibase.indexOf("//") !== -1 ? this.env.apibase : getbaseUrl(),
      "/"
    );
    let reconnectWaitTime = 5000;
    // const connection = new HubConnectionBuilder()
    //     .withUrl(`${base}/assignmentsgroup?authorization=${sessionStorage.getItem(this.env.jwt_name)}`,
    //         HttpTransportType.WebSockets || HttpTransportType.LongPolling)
    //     .build();

    const connection = new HubConnectionBuilder()
      .withUrl(`${base}/assignmentsgroup`, {
        accessTokenFactory: () => sessionStorage.getItem(this.env.jwt),
        logMessageContent: true,
        logger: signalR.LogLevel.Trace,
        httpClient: new CustomHttpClient(this.env, this.store),
      })
      .configureLogging(signalR.LogLevel.Trace)
      .build();
    connection
      .start()
      .catch(function (err) {
        return console.error(err.toString());
      })
      .then((_) => {
        connection.on("planning", (data: Assignment[]) => {
          this.store.dispatch(new ModifiedPlanningAction(data));
          this.store.dispatch(new ModifiedAssessmentResultAction(data));
        });

        connection.onclose(async () => {
          console.warn(
            `WS connection closed, try reconnecting with loop interval ${reconnectWaitTime}`
          );
          tryReconnect(connection);
        });
      });

    async function tryReconnect(connection) {
      try {
        let started = await connection.start();
        console.log("WS client connected!");

        // Here i'm initializing my services, e.g. fetch history of a chat when connection got established

        return started;
      } catch (e) {
        await new Promise((resolve) => setTimeout(resolve, reconnectWaitTime));
        return await tryReconnect(connection);
      }
    }
  }

  private setLocalStorage(key, value) {
    this.storageService.set(`previousSession-${this.userService.user.id}`, {
      [key]: value,
    });
  }
}

class CustomHttpClient extends signalR.DefaultHttpClient {
  constructor(private env: EnvService, private store: Store) {
    super(console);
  }

  public async send(
    request: signalR.HttpRequest
  ): Promise<signalR.HttpResponse> {
    const token = sessionStorage.getItem(this.env.jwt);
    const citomodule = this.store.selectSnapshot<number>(
      (state: any) => state.dashboard.module
    );
    const customHeaders = {
      Module: `${citomodule}`,
    }; // These are the extra headers I needed to put in

    request.headers = { ...request.headers, ...customHeaders };

    // Now we have manipulated the request how we want we can just call the base class method
    return super.send(request);
  }
}
